import { render } from "./ChildSafetyStandards.vue?vue&type=template&id=61066a62&scoped=true"
const script = {}

import "./ChildSafetyStandards.vue?vue&type=style&index=0&id=61066a62&scoped=true&lang=scss"

import exportComponent from "/Users/suhwanlim/Projects/pr/MoTobi-Web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61066a62"]])

export default __exports__